import { ReactNode, useCallback, useMemo, useState } from "react";
import VisorFactura from "./VisorFactura";
import { VisorFacturaContext } from "./visorFacturaContext";

// Mantiene la pila de facturas consultadas (se puede navegar de una a otra y volver) y muestra la actual en el visor.
// Va en la raíz de la aplicación para que el visor se abra por encima de cualquier detalle.
const VisorFacturaProvider = ({ children }: { children: ReactNode }) => {
  const [pila, setPila] = useState<string[]>([]);

  const abrir = useCallback((facturaId: string) => {
    setPila(prev => (prev[prev.length - 1] === facturaId ? prev : [...prev, facturaId]));
  }, []);

  const valor = useMemo(() => ({ abrir }), [abrir]);
  const actual = pila[pila.length - 1];

  return (
    <VisorFacturaContext.Provider value={valor}>
      {children}
      {actual && (
        <VisorFactura
          key={actual}
          facturaId={actual}
          puedeVolver={pila.length > 1}
          onVolver={() => setPila(prev => prev.slice(0, -1))}
          onClose={() => setPila([])}
        />
      )}
    </VisorFacturaContext.Provider>
  );
};

export default VisorFacturaProvider;
